import axios from './axios'
import { getLocalStorage } from '@/utils/tools.js'
export function getUserFiles(options){
    return axios.get('/api/v1/web/user_form/get_data_bank?status=' + options.status + '&page=' + options.page);
}

export function getUserForm(options){
    return axios.get('/api/v1/web/user_form/form_list?page=' + options.page);
}
export function getContractDetailInfo(options){
    return axios.get('/api/v1/web/user_form/user_consent_form?id=2&form_id=' + options.id)
}
export function getFileToSee(options){
    return axios.get('/api/v1/web/user_form/user_consent_form?id='+options.id);
}

export function getUserFormInfo(options){
    return axios.get('/api/v1/web/user_form/form_status?form_id='+options.id);
}

export function affirmForm(options){
  return axios.get('/api/v1/web/user_form/affirm/'+options.id);
}



export function uploadSignatureImg(options){
    let headers = {
        headers: {
            // "Content-Type": "multipart/form-data",
            Authorization: getLocalStorage('token')
        }
    }
    return axios.post('/api/v1/web/user_form/upload_consent_image',options,headers)
}